<script lang="ts" setup>
import Help from '../display/Help.vue'
import type { GETConnection, PortProApiConfig } from '~/services/apiClient'

const props = defineProps<{
  connection: GETConnection
}>()
const conn = toReactive(props.connection)
const tmsName = 'Port Pro'
const documentationLink = undefined
const config = reactive(conn.config as PortProApiConfig)
const formRules = undefined
</script>

<template>
  <IntegrationConnection
    :connection="props.connection"
    tms-name="Port Pro"
    :documentation-link="documentationLink"
    :form-rules="formRules"
  >
    <el-form-item label="Refresh Token:">
      <el-input
        v-model="config.refresh_token"
        style="width: 200px"
        placeholder="Refresh Token"
        show-password
        :disabled="props.connection.config.client_id !== ''"
      />
      <Help title="Refresh Token" class="ml-2"
        >Only required only if we did not integrate using your client ID. It can
        be retrieved from
        <a
          href="https://app.portpro.io/settings/developer-settings"
          target="_blank"
          >here</a
        >.
        <a v-if="documentationLink" :href="documentationLink" target="_blank">
          See our help doc on this.
        </a>
      </Help>
    </el-form-item>
    <BaseIntegrationConnectionSettings
      :model-value="config"
      :documentation-link="documentationLink"
      :tms-name="tmsName"
    />
    <TmsTerminalCodeMapping
      :model-value="config.tms_terminal_mapping"
      tms-name="Port Pro"
      documentation-link=""
    />
  </IntegrationConnection>
</template>

<style scoped lang="scss">
.el-input {
  max-width: 400px !important;
}
</style>
